import React from 'react';
import _ from 'lodash';
import ChartLoader from '@/pages/dashboard/_charts/ChartLoader';
import DonutChart from '@/pages/dashboard/_charts/DonutChart';
import colors from 'tailwindcss/colors';
import {useEventsContext} from '@/pages/dashboard/EventsContext';

export default function EventResponseYear(props) {
  const {subtitle} = props;
  const {filteredEvents, isLoadingEvents} = useEventsContext();

  if (isLoadingEvents) {
    return (
      <ChartLoader
        title="Events by Partner Status"
        subtitle={subtitle || 'For school year'}
      />
    );
  }

  // group each event into a single prioritized category
  const counts = _.reduce(filteredEvents, (acc, event) => {
    if (event.yesResponsesCount) acc.yes++;
    else if (event.maybeResponsesCount) acc.maybe++;
    else if (event.pendingResponsesCount) acc.pending++;
    else if (event.noResponsesCount) acc.no++;
    else if (event.noInvitesCount) acc.noInvites++;
    return acc;
  }, {yes: 0, maybe: 0, pending: 0, no: 0, noInvites: 0});

  const series = [
    counts.yes,
    counts.maybe,
    counts.pending,
    counts.no,
    counts.noInvites
  ];

  const labels = [
    'Yes',
    'Maybe',
    'Pending',
    'No',
    'No invites'
  ];

  return (
    <DonutChart
      title="Events by Partner Status"
      subtitle={subtitle || 'For school year'}
      labels={labels}
      series={series}
      colors={[
        colors.emerald['400'],
        colors.lime['400'],
        colors.yellow['400'],
        colors.red['400'],
        colors.blue['400']
      ]}
    />
  );
}
